// extracted by mini-css-extract-plugin
export default {"sector":"Sector_sector__wEWg+","icon-container":"Sector_icon-container__mmucR","info-container":"Sector_info-container__w5jyK"};